import {onClick} from '../abstract/helpers.js';

export class HoverPopups {
  constructor(name, options) {

    let tags = document.querySelectorAll('.single-detail .main .content-area.has-ajax-hover a');
    if(tags) {
      tags.forEach(function(el){
        let link = el.href;

        fetch(link, {
          method: 'GET',
        })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
    
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          let title = doc.querySelector('title');
          let desc = doc.querySelector('meta[name="description"]');

          if(typeof(title) != 'undefined' && title != null && typeof(desc) != 'undefined' && desc != null) {

            let svg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 7V2C14 2 10.9526 2 9 2" stroke="#4F6B74" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/><path d="M8 7.99828L13.5764 2.42188" stroke="#4F6B74" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/><path d="M14 10V13.3333C14 13.5101 13.9298 13.6797 13.8047 13.8047C13.6797 13.9298 13.5101 14 13.3333 14H2.66667C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V2.66667C2 2.48986 2.07024 2.32029 2.19526 2.19526C2.32029 2.07024 2.48986 2 2.66667 2H6" stroke="#4F6B74" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/></svg>';
            let popup = "<div class='hover'><p class='description'>"+desc.content+"</p><p class='title'>"+svg+title.innerHTML+"</p></div>";

            el.innerHTML += popup;

          }
    
        }.bind(this).bind(el)).catch(function (err) {
          console.warn('Error generating popup.', err);
        });

      });
    }
  }
}
